import Typography from 'components/shared/generic/typography/presentational/Typography';
import Loading from '_content/images/icons/more/loading.png';
import Button, {
    ButtonTypes,
} from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';
import { getTheme } from 'selectors/darkMode';
import { useSelector } from 'react-redux';

interface CheckProps {
    error?: string;
    handleTryAgain?: () => void;
}

export const Check = ({ error, handleTryAgain }: CheckProps) => {
    const isDarkModeEnabled = useSelector(getTheme);
    const translate = useTranslate('check');
    return (
        <div className="login-container checking-container d-flex-col-center">
            <div className="checking-box">
                {!error ? (
                    <div
                        className={`checking-content ${
                            isDarkModeEnabled ? 'dark-mode' : ''
                        }`}
                    >
                        <Typography tag="h1">
                            {translate('headerText')}
                        </Typography>
                        <img alt="loading" src={Loading} className="mb-2" />
                        <Typography tag="p">
                            {translate('description')}
                        </Typography>
                    </div>
                ) : (
                    <div
                        className={`error-content ${
                            isDarkModeEnabled ? 'dark-mode' : ''
                        }`}
                    >
                        <Typography tag="h1">{error}</Typography>
                        <Button
                            onClick={handleTryAgain}
                            type={ButtonTypes.BUTTON}
                        >
                            {translate('tryAgain')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
